module.exports = "/_next/static/images/65b91b9e8d0c04f0050adf836a5855f5-roxinho-single-xs@1x.jpg.webp";